import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/monthly-data-entrys',
    name: 'monthlyDataEntry',
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '',
        name: 'monthlyDataEntryList',
        component: () => import('../pages/MonthlyDataEntryListPage.vue')
      },
      {
        path: ':personId/:educationId',
        name: 'educationMonthList',
        component: () => import('../relations/education-month/pages/EducationMonthListPage.vue'),
        props: true
      }
    ]
  }
];

export default routes;
